import React, { useState, useRef, useEffect, useMemo } from "react";
import "./TenantDropdown.css";

export default function TenantDropdown({ tenants, value, onChange }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const containerRef = useRef(null);
  const searchRef = useRef(null);

  const current = tenants.find((t) => t.code === value);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return tenants;
    return tenants.filter(
      (t) => (t.name || "").toLowerCase().includes(q) || t.code.toLowerCase().includes(q)
    );
  }, [tenants, search]);

  useEffect(() => {
    if (open) searchRef.current?.focus();
    else setSearch("");
  }, [open]);

  useEffect(() => {
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const select = (t) => {
    onChange(t.code);
    setOpen(false);
  };

  return (
    <div className="td-root" ref={containerRef}>
      <button className="td-trigger" onClick={() => setOpen((o) => !o)}>
        <span className="td-trigger-label">{current?.name || current?.code || value}</span>
        <svg className={`td-chevron${open ? " open" : ""}`} width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <path d="M2 4L6 8L10 4" />
        </svg>
      </button>

      {open && (
        <div className="td-panel">
          <div className="td-search-wrap">
            <input
              ref={searchRef}
              className="td-search"
              type="text"
              placeholder="Search…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div className="td-list">
            {filtered.length === 0 && (
              <div className="td-empty">No results</div>
            )}
            {filtered.map((t) => (
              <button
                key={t.code}
                className={`td-option${t.code === value ? " active" : ""}`}
                onClick={() => select(t)}
              >
                <span className="td-option-name">{t.name || t.code}</span>
                <span className="td-option-code">{t.code}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
